import {createActionCreator, createVoidActionCreator} from '../common/actions';

export const DownloadShareClicked = createActionCreator<JobID>('DOWNLOAD_SHARE_CLICKED');
export const DownloadShareSuccess = createActionCreator<JobID>('DOWNLOAD_SHARE_SUCCESS');
export const DownloadShareFailed = createActionCreator<JobID>('DOWNLOAD_SHARE_FAILED');

export const ShareCopiedToTimeline = createVoidActionCreator('SHARE_COPIED_TO_TIMELINE');
export const ShareCopiedToTimelineFailed = createVoidActionCreator('SHARE_COPIED_TO_TIMELINE_FAILED');
